import {FC, Fragment, MouseEventHandler, useContext} from "react";
import { ImgRounded } from "../atoms/ImgRounded";
import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { classNames } from "@/shared/utils/classnames";
import {useSelector} from "react-redux";

export type ConversationItemProps = {
  isLoading?: boolean;
  conversation?: any;
  onClick?: MouseEventHandler;
  current?: boolean;
  support?: boolean;
};

export const ConversationItem: FC<ConversationItemProps> = ({
  conversation,
  isLoading,
  onClick,
  current,
  support,
}) => {
  const [t] = useTranslation();
  const userId = useSelector((state: any) => state?.auth?.user?.id);

  return (
    <Fragment>
      <li onClick={onClick}>
        <div className="group relative flex items-center px-5 py-6">
          <a href="#" className="-m-1 block flex-1 p-1">
            <div
              aria-hidden="true"
              className={classNames(
                "absolute inset-0 group-hover:bg-gray-50",
                current ? "!bg-gray-200" : ""
              )}
            />
            <div className="relative flex min-w-0 flex-1 items-center gap-4">
              <span className="relative inline-block flex-shrink-0">
                {isLoading ? (
                  <div className="bg-gray-300 rounded-full w-12 h-12 animate-pulse" />
                ) : (
                  <ImgRounded
                    src={
                      conversation?.managerId !== userId
                        ? conversation?.manager?.avatar
                        : conversation?.client?.avatar
                    }
                    size="extraLarge"
                  />
                )}
              </span>
              <div className="flex flex-col truncate flex-1 gap-2">
                {isLoading ? (
                  <div className="w-full bg-gray-300 animate-pulse rounded-sm h-4" />
                ) : (
                  <p className="truncate text-sm font-medium text-gray-900">
                    {conversation?.managerId !== userId
                      ? conversation?.manager?.name
                      : conversation?.client?.name}
                  </p>
                )}

                {isLoading ? (
                  <Fragment>
                    <div className="w-2/4 bg-gray-300 animate-pulse rounded-sm h-4" />
                    <div className="w-12 bg-gray-300 animate-pulse rounded-sm h-4" />
                  </Fragment>
                ) : (
                  <Fragment>
                    {conversation?.chateableType == "App\\Message" && (
                      <Fragment>
                        <p className="truncate text-sm text-gray-500 text-wrap">
                          {conversation.chateable.isFile
                            ? t("chat.app.sent_an_attachment")
                            : conversation?.chateable?.content}
                        </p>
                        <small className="truncate text-sm text-gray-400">
                          {DateTime.fromISO(
                            conversation?.chateable?.createdAt
                          ).toFormat("dd-MM-yyyy")}
                        </small>
                      </Fragment>
                    )}
                    {conversation?.chateableType == "App\\Post" && (
                      <Fragment>
                        <p className="truncate text-sm text-gray-500">
                          {conversation?.chateable?.content}
                        </p>
                        <small className="truncate text-sm text-gray-400">
                          {DateTime.fromISO(
                            conversation?.chateable?.createdAt
                          ).toFormat("dd-MM-yyyy")}
                        </small>
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </div>
              <div className="flex flex-col justify-center gap-4">
                {conversation?.notification > 0 && (
                  <span className="bg-primary-500 h-6 min-w-6 text-center text-sm rounded-full text-white">
                    {conversation?.notification}
                  </span>
                )}
                {conversation?.status == 2 && (
                  <FontAwesomeIcon icon={faStar} className="text-primary" />
                )}
              </div>
            </div>
          </a>
        </div>
      </li>
    </Fragment>
  );
};
